module.exports = __webpack_public_path__ + "img/no-tier-icon.981a3f0c.svg";